<!--
 * @Description: 
 * @Author: 王佳兴
 * @Github: 
 * @Date: 2019-01-03 14:50:20
 * @LastEditors: wjx
 * @LastEditTime: 2019-03-05 10:59:40
 -->
<template>
  <div class="box">
    <img class="bg" :src="bg.picurl" alt @click="jump(bg)" />
    <ul>
      <li v-for="(item, index) in list" :key="index" @click="jump(item)">
        <p>{{ item.title }}</p>
        <img :src="item.picurl" alt />
      </li>
    </ul>
  </div>
</template>
<script>
import { pushTemp } from '@/api/ajax.js';
import { InlineLoading } from 'vux';
export default {
  props: {},
  data() {
    return {
      list: [],
      bg: {}
    };
  },
  methods: {
    jump(item) {
      this.$sa.setSaSession_href(this.$route, item.url);
    }
  },
  components: {},
  computed: {},
  created() {
    pushTemp.todayArticles().then(res => {
      let { list, sendMap } = res.data.data;
      this.bg = list[0];
      this.list = list.slice(1, list.length);
      this.$wxShareInfo(
        sendMap.title,
        sendMap.description,
        sendMap.picurl,
        location.href
      );
    });
  },
  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
@import '../../public/style/g.less';
.box {
  padding: 0.4rem;
  position: absolute;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  background: #eee;
  .bg {
    width: 9.2rem;
    height: 3.89rem;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
  }
  ul {
    // width: 9.2rem;
    padding: 0 0.4rem;
    background: #fff;
    li {
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;
      padding-bottom: 0.23rem;
      padding-top: 0.31rem;

      &:before {
        content: '';
        width: 6.53rem;
        height: 0.04rem;
        background: #e5e5e5;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      p {
        .lineClamp();
        width: 6.53rem;
        margin-right: 0.73rem;
        font-size: 0.43rem;
        color: #333333;
        line-height: 0.59rem;
      }
      img {
        width: 1.6rem;
        height: 1.6rem;
      }
    }
    li:last-child {
      &:before {
        display: none;
      }
    }
  }
}
</style>
